<template>
  <div class="app-body">
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item prop="orderCode" label="订单编号：">
        <el-input v-model="dataForm.orderCode" size="mini" clearable type="text"
                  placeholder="订单编号"></el-input>
      </el-form-item>
      <!--      <el-form-item prop="batchCode" label="批次号：">-->
      <!--        <el-input v-model="dataForm.batchCode" size="mini" clearable type="text"-->
      <!--                  placeholder="加工批次"></el-input>-->
      <!--      </el-form-item>-->
      <!--      <el-form-item prop="receiverName" label="收货方："  v-if="optType===10">-->
      <!--        <el-input v-model="dataForm.receiverName" size="mini" clearable type="text"-->
      <!--                  placeholder="收货方"></el-input>-->
      <!--      </el-form-item>-->
      <el-form-item prop="productCode" label="品番号：">
        <el-input
            v-model="dataForm.productCode"
            size="mini"
            clearable
            type="text"
            placeholder="品番号"
        ></el-input>
      </el-form-item>
      <el-form-item prop="skuCode" label="SKU：">
        <el-input
            v-model="dataForm.skuCode"
            size="mini"
            clearable
            type="text"
            placeholder="SKU"
        ></el-input>
      </el-form-item>
      <el-form-item prop="nameZh" label="中文品名：">
        <el-input
            v-model="dataForm.nameZh"
            size="mini"
            clearable
            type="text"
            placeholder="中文品名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productName" label="`品名：`">
        <el-input
            v-model="dataForm.productName"
            size="mini"
            clearable
            type="text"
            placeholder="品名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productColor" label="颜色：">
        <el-input
            v-model="dataForm.materialColor"
            size="mini"
            clearable
            type="text"
            placeholder="颜色"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productSize" label="规格：">
        <el-input
            v-model="dataForm.productSize"
            size="mini"
            clearable
            type="text"
            placeholder="规格"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="reload()" size="mini">{{ $t('query') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="table-bar" style="justify-content: left;margin-bottom: 0px;">
      <div class="bar-item">
        <el-button type="primary" @click="doSend(optType)" size="mini" v-if="$hasPermission('erp:receive:send')">配件发货
        </el-button>
        <el-button type="warning" @click="doSend(30)" size="mini" v-if="$hasPermission('erp:receive:send')">箱单发货
        </el-button>
      </div>
    </div>
    <SweetTable api-version="v2" ref="table" :before-table-binding="beforeTableBinding" :selection="true"
                url="/erp/make/detail/page" :query-form="dataForm">
      <el-table-column
          prop="orderCode"
          label="订单编号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="batchCode"
          label="批次号"
          header-align="center"
          align="center"
          min-width="90"
          :show-overflow-tooltip="true"
      ></el-table-column>

      <el-table-column
          prop="product.code"
          label="品番号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.skuCode"
          label="SKU"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.name"
          label="品名"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.nameZh"
          label="中文品名"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.color"
          label="颜色"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.size"
          label="规格"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column prop="amount" label="单价" width="100" header-align="center" align="center">
      </el-table-column>
      <el-table-column
          prop="count"
          label="计划数量"
          header-align="center"
          align="center"
          width="100"
      >
      </el-table-column>
      <el-table-column
          label="待收货"
          header-align="center"
          align="center"
          prop="sendCount"
          width="100"
      >
      </el-table-column>
      <el-table-column
          prop="receiveCount"
          label="已收货"
          header-align="center"
          align="center"
          width="100"
      ></el-table-column>
      <el-table-column
          prop="totalSendCount"
          label="总发货数"
          header-align="center"
          align="center"
          width="100"
      ></el-table-column>
      <el-table-column
          label="下单人"
          header-align="center"
          align="center"
          prop="creatorName"
          width="120"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          label="下单时间"
          header-align="center"
          align="center"
          prop="createDate"
          width="160"
      >
      </el-table-column>
    </SweetTable>
    <ReceiveProduct ref="ReceiveProduct"
                @change="()=>{this.getDataList();this.$refs.table.clearSelection();}"></ReceiveProduct>
    <ReceiveBox ref="ReceiveBox"
                @change="()=>{this.getDataList();this.$refs.table.clearSelection();}"></ReceiveBox>
  </div>
</template>

<script>
/**
 * 成品加工订单,供应商专用页面,只显示状态已发送的数据
 */
import SendDialog from './send-dialog.vue'
import SweetTable from '@/mixins/SweetTable'
import Bignumber from 'bignumber.js'
import ReceiveProduct from '@/views/modules/erp/receive/receive-product.vue'
import ReceiveBox from '@/views/modules/erp/receive/receive-box.vue'
export default {
  name: 'make-order',
  mixins: [SweetTable],
  components: { SendDialog,ReceiveProduct },
  data () {
    return {
      dateArr: [],
      currentId: '',
      sendOptType: 0,//操作类型,10物料发货,20成品发货,30箱单发货
      dataForm: {
        orderCode: '',
        batchCode: '',
        productCode: '',
        skuCode: '',
        nameZh: '',
        productName: '',
        productColor: '',
        productSize: '',
        productAttr1: '',
        productAttr2: '',
        receiverName: '',
      },
    }
  },
  computed: {
    showName () {
      if (this.optType === 10) {
        return '物料'
      } else if (this.optType === 20) {
        return '品番'
      }
    }
  },
  methods: {
    doSend (sendType) {
      this.sendOptType = sendOptType
      if (this.$c.isArrayEmpty(this.$refs.table.dataListSelections)) {
        return this.$message.error('请选择发货内容')
      }
      let detailList = this.$refs.table.dataListSelections.map(row => {
        return {
          orderCode: row.orderCode,
          orderId: row.agreementId || row.orderId,
          sourceId: row.id,
          productId: row.productId,
          product: row.product,
          count: '',
          receiverId: row.storageId,
          receiverName: row.storageName,
          remark: '',
          orderCount: row.count,
          receivedCount: row.receivedCount,
          sendCount: row.sendCount,
          price: 0
        }
      })
      if(sendType==='product'){
        this.$refs.ReceiveProduct.init(detailList)
      }else if(sendType==='box'){
        this.$refs.ReceiveBox.init(detailList)
      }
    },
    beforeTableBinding (dataList) {
      dataList.forEach(row => {
        row.receiveCount = new Bignumber(row.totalSendCount).minus(row.sendCount).toFixed(3)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.count-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 10px;
}
</style>



